import { createAction } from '@reduxjs/toolkit';

import { requestObject } from '../Instance/Actions';
import { InstanceType } from '../Instances/Instances';

export interface KanbanBoardState {
    KanbanLanes: any
    CandidateStages: any
    GroupedSubStages: any
}

export const initialState: KanbanBoardState = {
    KanbanLanes: {},
    CandidateStages: {},
    GroupedSubStages: {}
}

export const setKanbanLanes = createAction<any>('kanbanBoard/setKanbanLanes');
export const setCandidateStages = createAction<any>('kanbanBoard/setCandidateStages');
export const setGroupedSubStages = createAction<any>('kanbanBoard/setGroupedSubStages');

export const reloadStageCounts = (JOB_ID: string) => requestObject({
    instanceType: InstanceType.WORKFLOW_STAGES_COUNT,
    dynamicUrlData: `/${JOB_ID}/StageCounts`
  });